var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 27.3334C6.63599 27.3334 0.666656 21.3641 0.666656 14.0001C0.666656 6.63608 6.63599 0.666748 14 0.666748C21.364 0.666748 27.3333 6.63608 27.3333 14.0001C27.3333 21.3641 21.364 27.3334 14 27.3334ZM14 12.1147L10.2293 8.34275L8.34266 10.2294L12.1147 14.0001L8.34266 17.7707L10.2293 19.6574L14 15.8854L17.7707 19.6574L19.6573 17.7707L15.8853 14.0001L19.6573 10.2294L17.7707 8.34275L14 12.1147Z",
    fill: "#293990"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.a97fac9be7ec46ce182ca7b73ac956d9.svg";
export { ForwardRef as ReactComponent };